var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-page"},[_c('div',{staticClass:"container"},[(_vm.$route.name !== 'result')?_c('Nav'):_vm._e(),_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('router-view',{key:_vm.$route.path})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }